import React from 'react';
import { Button } from '@/lib/shadcn/components/ui/button';

interface PageHeaderProps {
  title: string;
  description?: string;
  /** Extra controls (e.g. filters) shown before the primary action. */
  filters?: React.ReactNode;
  action?: {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  };
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  filters,
  action,
  className = '',
}) => {
  return (
    <div
      className={`flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-start mb-6 ${className}`}
    >
      <div>
        <h1 className="text-2xl font-semibold">{title}</h1>
        {description && <p className="text-muted-foreground">{description}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2 sm:justify-end">
        {filters}
        {action && (
          <Button onClick={action.onClick}>
            {action.icon}
            {action.label}
          </Button>
        )}
      </div>
    </div>
  );
};